import { Box, Card, Skeleton, Typography, styled, useTheme } from "@mui/material";
import { memo, useEffect, useState } from "react";
import Chart from "react-apexcharts";
import "react-circular-progressbar/dist/styles.css";
import noDataImg from "../../Images/noDataImg.png";
import { convertUTCDateToLocalDate } from "../../utils/myUtills";

const BoxWrapper = styled(Box)(({ theme }) => ({
  minHeight: "100%",
  "& .MainHead": {
    "& .Updated": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "6px",
      border: "1px solid #00CF00",
      padding: "4px 10px 4px 4px",
      borderRadius: "50px",
      "& img": {
        width: "16px",
        height: "16px",
      },
      "& span": {
        color: "#00CF00",
        fontSize: "12px",
        fontWeight: 600,
        lineHeight: "1",
      },
    },
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    "& h2": {
      color: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
      fontSize: "18px",
      fontWeight: 700,
      lineHeight: "1",
    },
  },
  "& .GraphWrapper": {
    "& .NoDataWrapper": {
      minHeight: "300px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      "& .ImgWrapper": {
        textAlign: "center",
        marginBottom: "10px",
        "& img": {},
      },
      "& .ContentWrapper": {
        "& h3": {
          color: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
          textAlign: "center",
          marginBottom: "10px",
          fontSize: "16px",
          fontWeight: 600,
          lineHeight: "1",
        },
        "& p": {
          color: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
          textAlign: "center",
          fontSize: "14px",
          marginBottom: "10px",
          "& span": {
            color: theme.palette.primary.main,
            fontWeight: 600,
          },
        },
      },
    },
  },
}));

function KeywordTrands({ keywordTrand, searchKeywords, label, loading = true }) {
  const theme = useTheme();
  const [chartData, setChartData] = useState(null);
  useEffect(() => {
    const newChartData = {
      series: [
        {
          name: "Keyword trands",
          data: keywordTrand.map(item => item[searchKeywords]),
        },
      ],
      options: {
        chart: {
          type: "line",
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            borderRadius: 5,
            columnWidth: "20%",
          },
        },
        xaxis: {
          categories: keywordTrand.map(item => convertUTCDateToLocalDate(item.date)),
          axisBorder: {
            show: true,
          },
          axisTicks: {
            show: false,
          },
        },
        yaxis: {
          show: true,
        },
        grid: {
          show: true,
        },
        tooltip: {
          enabled: true,
        },
        dataLabels: {
          enabled: false,
        },
        colors: ["#01C0C8"],
      },
    };
    setChartData(newChartData);
  }, [keywordTrand]);

  return (
    <BoxWrapper>
      <Card sx={{ padding: "24px 24px 24px 24px", border: `1px solid ${theme.palette.divider}`, boxShadow: "none !important" }}>
        <Box className="MainHead">
          <Typography component="h2">Keyword Trends</Typography>
        </Box>
        <Box className="GraphWrapper">
          {loading ? (
            <Box sx={{ width: "100%", padding: "30px 0px 0px" }}>
              <Skeleton variant="rectangular" width="100%" height={180} />
            </Box>
          ) : (
            <Box sx={{ width: "100%", margin: "0 auto" }}>
              {chartData && Array.isArray(keywordTrand) && keywordTrand.length > 0 ? (
                <Chart options={chartData.options} series={chartData.series} type="line" height={200} />
              ) : (
                <Box className="NoDataWrapper">
                  <Box className="ImgWrapper">
                    <Typography component="img" src={noDataImg} alt="No data available" />
                  </Box>
                  <Box className="ContentWrapper">
                    <Typography component="h3">No data</Typography>
                    <Typography component="p">
                      We couldn t find any {label} for <Typography component="span"> {searchKeywords}</Typography>
                    </Typography>
                  </Box>
                </Box>
              )}
            </Box>
          )}
        </Box>
      </Card>
    </BoxWrapper>
  );
}

export default memo(KeywordTrands);
